// extracted by mini-css-extract-plugin
export default {"container":"AnalysisTextArea_container__yCav2","editor":"AnalysisTextArea_editor__yCcKz"};